var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 94C4 91.7909 5.79086 90 8 90H19.2811C19.7458 90 20.196 90.1618 20.5544 90.4577L26.7266 95.5538C27.4659 96.1641 28.5341 96.1641 29.2734 95.5538L35.4456 90.4577C35.804 90.1618 36.2542 90 36.7189 90H48C50.2091 90 52 91.7909 52 94V121H4V94Z",
    fill: "url(#paint0_radial_3124_25302)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 59,
    width: 23,
    height: 27,
    rx: 10,
    fill: "url(#paint1_radial_3124_25302)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125 7H72V43H125V7ZM81 11C78.7909 11 77 12.7909 77 15V23H85C87.2091 23 89 21.2091 89 19V11H81Z",
    fill: "url(#paint2_radial_3124_25302)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 49,
    width: 6,
    height: 6,
    stroke: "url(#paint3_radial_3124_25302)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 49,
    width: 6,
    height: 6,
    stroke: "url(#paint4_radial_3124_25302)",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 49,
    width: 6,
    height: 6,
    stroke: "url(#paint5_radial_3124_25302)",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 49,
    width: 6,
    height: 6,
    stroke: "url(#paint6_radial_3124_25302)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 105V105.5H100.5V105H100ZM58 105L63 107.887V102.113L58 105ZM99.5 59V105H100.5V59H99.5ZM100 104.5H62.5V105.5H100V104.5Z",
    fill: "url(#paint7_linear_3124_25302)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24L59 21.1132V26.8868L64 24ZM29 24V23.5H28.5V24H29ZM59.5 23.5H29V24.5H59.5V23.5ZM28.5 24V52.5H29.5V24H28.5Z",
    fill: "url(#paint8_linear_3124_25302)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3124_25302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 90) rotate(90) scale(32.1341 49.7561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3124_25302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8514 67.2317) rotate(130.184) scale(24.5665 21.9926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3124_25302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.527 17.9756) rotate(145.585) scale(44.2769 37.4912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3124_25302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.5135 50.439) rotate(134.754) scale(7.83092 7.11042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3124_25302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.5135 50.439) rotate(134.754) scale(7.83092 7.11042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3124_25302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.514 50.439) rotate(134.754) scale(7.83092 7.11042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3124_25302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.514 50.439) rotate(134.754) scale(7.83092 7.11042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3124_25302",
    x1: 79,
    y1: 59,
    x2: 79,
    y2: 105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3124_25302",
    x1: 46.5,
    y1: 24,
    x2: 46.5,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF",
    stopOpacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFinance);
export default __webpack_public_path__ + "static/media/ic_finance.146363c6d2c066568da67908a9d86288.svg";
export { ForwardRef as ReactComponent };